import React from 'react'
import styled from 'styled-components/macro'

const Env = styled.div`
  font-family: monospace;
  white-space: pre-wrap;
  line-height: 1.5;
`

const Environment = () => {
  return <Env>{JSON.stringify(process.env, null, 2)}</Env>
}

export default Environment
